import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiPageTemplate,
  EuiText,
} from "@inscopix/ideas-eui";
import assert from "assert";
import { useParams } from "react-router-dom";
import { ToolEditor } from "./ToolEditor";
import { ProjectPageContent } from "pages/gdt/layout/ProjectPageContent";
import { RoleBadge } from "components/RoleBadge/RoleBadge";
import { useMemo } from "react";
import { useProjectPermissionStore } from "pages/project/ProjectPermissionProvider";
import { ToolBreadcrumbs } from "components/HeaderBreadcrumbs/ToolBreadCrumbs";
import { useSetAppHeader } from "providers/AppHeaderProvider";
import { useTenantContext } from "providers/TenantProvider/TenantProvider";
import { useToolDataContext } from "pages/tool/ToolDataProvider";

interface PageToolEditorProps {
  resetDataTableProviderKey: () => void;
  setTableKey: (key: string | undefined) => void;
}

export const PageToolEditor = ({
  resetDataTableProviderKey,
  setTableKey,
}: PageToolEditorProps) => {
  const { tool, invalidateToolQuery } = useToolDataContext();
  const currentTenant = useTenantContext((s) => s.currentTenant);
  const { toolVersionId } = useParams<{ toolVersionId: string | undefined }>();

  // set header
  const breadcrumbs = useMemo(() => {
    return (
      <ToolBreadcrumbs
        key={"breadcrumbs"}
        tool={tool}
        currentTenant={currentTenant}
        inDraftMode={true}
        invalidateToolQuery={() => void invalidateToolQuery()}
      />
    );
  }, [tool, currentTenant, invalidateToolQuery]);
  useSetAppHeader({ header: breadcrumbs });

  const role = useProjectPermissionStore((s) => s.permissions.role_display);
  assert(toolVersionId !== undefined);

  return (
    <EuiPageTemplate responsive={[]} restrictWidth={false}>
      <ProjectPageContent>
        <EuiPageTemplate.Header
          pageTitle={
            <EuiFlexGroup
              gutterSize={"s"}
              alignItems="center"
              responsive={false}
            >
              <EuiFlexItem grow={false}>
                <EuiText>
                  <h2>{tool.name}</h2>
                </EuiText>
              </EuiFlexItem>
              <EuiFlexItem grow={false}>
                <RoleBadge role={role} />
              </EuiFlexItem>
            </EuiFlexGroup>
          }
        />
        <EuiPageTemplate.Section contentProps={{ style: { flexGrow: 1 } }} grow>
          <ToolEditor
            toolVersionId={Number(toolVersionId)}
            resetDataTableProviderKey={resetDataTableProviderKey}
            setTableKey={setTableKey}
          />
        </EuiPageTemplate.Section>
      </ProjectPageContent>
    </EuiPageTemplate>
  );
};
